/**
 * This wrapper exists purely to allow for spying on calls to assign in tests, as JSDOM makes it impossible to spy on window.location.assing directly
 */
export const locationAssign: typeof window.location.assign = (...args) => {
  window.location.assign(...args);
};
